import { Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

import { Stack } from 'apps/dashboard/shared/scripts/components';
import { DeliveryMethod } from 'apps/shared/scripts/__generated__/graphql.generated';
import { useYupValidation } from 'apps/shared/scripts/hooks';

import CardWidget from '../CardWidget';

import CardDeliveryFooter from './CardDeliveryFooter';
import CardDeliveryPreference from './CardDeliveryPreference';
import CardDeliverySuccess from './CardDeliverySuccess';
import CardDeliveryWarning from './CardDeliveryWarning';
import { DEFAULT_VALUES, FORM_FIELDS } from './constants';
import { FormValues } from './types';
import { schema } from './validation';

export interface Props {
  cardId: string;
  defaultValues?: FormValues;
  isSubmitting?: boolean;
  isSuccess?: boolean;
  onSubmit: (data: FormValues) => Promise<void>;
}

const CardDeliveryForm = ({
  cardId,
  defaultValues = DEFAULT_VALUES,
  isSubmitting,
  isSuccess,
  onSubmit,
}: Props) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    watch,
  } = useForm<FormValues>({
    defaultValues,
    resolver: useYupValidation<FormValues>(schema),
  });
  const preference = watch(FORM_FIELDS.DELIVERY_METHOD.name);

  return (
    <Row>
      <Col lg={{ span: 5, order: 'last' }}>
        <Stack minimal>
          <CardWidget id={cardId} />
        </Stack>
      </Col>
      <Col lg={{ span: 7, order: 'first' }}>
        <Stack>
          {isSuccess ? (
            <CardDeliverySuccess cardId={cardId} preference={preference} />
          ) : (
            <form>
              <CardDeliveryPreference
                control={control}
                errors={errors}
                preference={preference}
              />
              {preference === DeliveryMethod.Email && <CardDeliveryWarning />}
              <CardDeliveryFooter
                isSubmitting={isSubmitting}
                onSubmit={handleSubmit(onSubmit)}
                watch={watch}
              />
            </form>
          )}
        </Stack>
      </Col>
    </Row>
  );
};

CardDeliveryForm.displayName = 'CardDeliveryForm';

export default CardDeliveryForm;
